import React from "react";
import { rankWith, schemaMatches } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import SFSlider from "../../slider";
import SFTypography from "../../typography";
import { SFStack } from "../../grid";
import { useTranslation } from "react-i18next";

const SliderRenderer = ({
  data,
  handleChange,
  path,
  uischema,
  schema,
  errors,
}) => {
  const onChange = (e) => {
    const value = e.target.value;
    handleChange(path, value);
  };

  const { t } = useTranslation();
  return (
    <>
      <SFTypography variant="tableListDescription">
        {t(uischema.i18nKey)}
      </SFTypography>
      <SFStack
        direction="row"
        justifyContent="flex-start"
        spacing={1}
        alignItems="center"
      >
        <SFSlider
          sx={{ width: "50%" }}
          track="inverted"
          value={data ?? 0}
          onChange={onChange}
          valueLabelFormat={(value) => `${value}%`}
        />
        <SFTypography variant="tableListDescription">
          {`${(data ?? 0).toFixed()} - 100%`}
        </SFTypography>
      </SFStack>
    </>
  );
};

export const SliderTester = rankWith(
  165,
  schemaMatches((schema) => schema.slider === true)
);

export default withJsonFormsControlProps(SliderRenderer);
